

export default {
    "title": "Shipment",
    "entityName": "shipment",
    "pagination": {
        "rowsPerPage": 10,
        "page": 1,
        "sortBy": "id",
        "descending": true
    },
    "fields": [
        {
            full:true,
            "value": "pickup.name",
            "text": "Pickup point",
            "type": "text",
            "table": {
                "sortable": true,
                "filter": true
            },
        },
        {
            full:true,
            "value": "delivery.name",
            "text": "Delivery point",
            "type": "text",
            "table": {
                "sortable": true,
                "filter": true
            },
        },
    
        {
            "value": "country_code",
            "type": "hidden",
        },



        {
            "full":true,
            "value": "status",
            readonly: true,
            "text": "Status",
            "type": "text",
        },


        {
            "full":true,
            "value": "comment",
            "text": "Comment",
            "type": "textarea",
        }


    ],
    "actions": [
    ]
}